export class DataProcessContainer {
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public sourceType?: string,
    public sourceDetails?: string,
    public icon?: string,
    public importMode?: string,
    public transferIntoNextStage?: boolean,
    public mapping?: string
  ) {}
}
